export const VERSION = 'v1.0.8';

export const APP_COLORS = {
    LAVENDER: '#A6808C',
    SILVERPINK: '#CCB7AE',
    TIMBERWOLF: '#D6CFCB',
    OLDLAVENDER: '#706677',
    INDEPENDENCE: '#565264',
}

export const CHART_PALETTE = [
    '#80ced7',
    '#63c7b2',
    '#8e6c88',
    '#263d42',
    '#577590',
    '#f3ca40',
    '#f2a541',
    '#d4d2a5',
    '#928779',
    '#3a445d',
    '#6a2e35',
    '#b6d094',
    '#c8553d',
    '#1b4079',
    '#7f9c96',
    '#b0413e',
    '#ffffc7',
    '#473335',
    '#5fad41',
    '#3a0842',
    '#F49097',
    '#DFB2F4',
    '#79ADDC',
    '#FCF5C7',
    '#CC978E',
    '#519872',
    '#3B5249',
    '#BEC5AD',
    '#C4D7F2',
    '#A39B8B',
    '#716A5C',
    '#0B5563',
    '#5E5C6C',
    '#F56960',
    '#D5B0AC',
    '#CEA0AE',
    '#F97068',
    '#E3D26F',
    '#2F1B25',
]